module.exports = __webpack_public_path__ + "images/jnd30s.c19a.png";